export const eventTypeLabels: { [key: string]: string } = {
	CartWaitingForApproval: "Approval",
	CartApproved: "Cart Approved",
	CartRejected: "Cart Rejected",

	ShippingInTransit: "Shipping in Transit",
	ShippingInProgress: "Shipping in Progress",
	ShippingCompleted: "Shipping Completed",
	ShippingFailure: "Shipping Failure",

	OrderConfirmation: "Order",
	InvoiceCreated: "Invoice Created",
	ServiceBooking: "Service booking",
};


export const enum ShippingType {
  Pickup = 'Pickup',
  Normal = 'Normal',
  Urgent = 'Urgent',
  Fastest = 'Fastest',
  Consolidated = 'Consolidated',
  Single = 'Single'
}


export const enum DispatchType {
	Single = "Single",
	Immediate = "Immediate",
	Urgent = "Urgent",
	Fastest = "Fastest",
	Pickup = "Pickup"
}
